<template>
  <block style="padding-bottom: 60px;">
    <template slot="header">
      <span v-if="!past">Nueva Atención</span>
      <span v-else>Atención Realizada</span>
    </template>

    <div class="attention-type">
      <h4 v-if="!past" class="is-uppercase">Atención a Planificar</h4>
      <h4 v-else class="is-uppercase">Atención Realizada</h4>

      <div class="control-group">
        <attention-tree v-on:update:action="selectedActionId = $event"></attention-tree>
        <div class="control">
          <label for="attention-date">
            Fecha
            <input
              type="date"
              name="attention-date"
              v-model="selectedDueBy"
              class="attention-date"
            />
          </label>
        </div>
      </div>
    </div>
    <!--
    <div class="attention-details">
      <h4 class="is-uppercase">OBJETIVO</h4>
      <textarea v-model="details" placeholder="Describa el objetivo de la atención."></textarea>
    </div>
    -->
    <div v-if="!past" class="responsible">
      <h4 class="is-uppercase">Responsable de la atención</h4>
      <div class="multiselect-container">
        <multiselect
          :options-list="possibleResponsibleUsersForAttention"
          v-model="selectedResponsible"
        ></multiselect>
      </div>
      <input
        v-model="messageForResponsible"
        class="responsible-message"
        type="text"
        max="140"
        style="margin-top: 10px"
        placeholder="Comentario personal para responsable de tarea (máx. 140 caracteres)."
      />
    </div>
    <derivation-list v-show="!past" :derivations.sync="derivations"></derivation-list>

    <div class="actions">
      <button
        class="button is-primary add"
        :class="{ 'is-loading': loading }"
        :disabled="!isValid"
        @click="submit"
      >
        Agregar
      </button>
      <button class="button is-primary is-outlined cancel" :disabled="loading" @click="cancel">
        Cancelar
      </button>
    </div>
  </block>
</template>

<script>
import gql from "graphql-tag"
import PROFILE_DETAIL from "../home/graphql/Profile.gql"
import STUDENT_ATTENTIONS from "../attentions/graphql/StudentAttentions.gql"
import POSSIBLE_RESPONSIBLES from "./graphql/PossibleResponsibleUsersForAttention.gql"
import CREATE_ATTENTION from "./graphql/CreateAttention.gql"
import AttentionTree from "./AttentionTree.vue"
import Block from "@/components/_base/Block.vue"
import Multiselect from "@/components/shared/multiselect/Multiselect.vue"
import DerivationList from "@/components/_base/DerivationList.vue"
import OverlayedMixin from "@/mixins/OverlayedMixin"

export default {
  name: "ProfileNewAttention",
  mixins: [OverlayedMixin],
  props: {
    studentId: {
      type: String
    },
    user: {
      type: Object
    },
    past: {
      type: Boolean,
      default: false,
      desc: "Whether the attention is new or past"
    }
  },
  data() {
    return {
      loading: false,
      details: "",
      selectedActionId: -1,
      selectedCategoryId: -1,
      selectedPlanId: -1,
      possibleResponsibleUsersForAttention: [],
      selectedResponsible: null,
      messageForResponsible: null,
      selectedDueBy: null,
      derivations: []
    }
  },
  apollo: {
    possibleResponsibleUsersForAttention: {
      query: POSSIBLE_RESPONSIBLES,
      variables() {
        if (this.selectedActionId !== -1) {
          return {
            conditions: {
              categoryId: this.selectedCategoryId === -1 ? null : this.selectedCategoryId,
              planId: this.selectedPlanId === -1 ? null : this.selectedPlanId,
              actionId: this.selectedActionId === -1 ? null : this.selectedActionId
            }
          }
        } else {
          return {
            conditions: {
              categoryId: null,
              planId: null,
              actionId: null
            }
          }
        }
      },
      result() {
        // On result, clear the selected user
        this.selectedResponsible = null
      }
    }
  },
  computed: {
    isValid() {
      // Has selected a responsible id
      if (!this.past && (this.selectedResponsible == -1 || this.selectedResponsible == null)) {
        return false
      }

      // Has selected a action id
      if (this.selectedActionId == -1 || this.selectedActionId == null) {
        return false
      }

      // Has selected a date
      if (this.selectedDueBy === null) {
        return false
      }

      // User must write some details about the alert

      return true
    },
    validDerivations() {
      if (this.derivations && this.derivations.length && this.derivations[0]["chosenUser"]) {
        const derivations = this.derivations.map(d => {
          return {
            userId: d.chosenUser.id,
            message: d.message
          }
        })
        // Filter the ones without a user
        const validDerivations = derivations.filter(d => d.userId != null)
        return validDerivations
      } else {
        return null
      }
    }
  },
  methods: {
    navigateTo(route) {
      console.log(`Navigating to...${route}`)
      this.$emit("hello", route)
    },

    getAttentionInput() {
      const baseInput = {
        studentId: this.studentId,
        attentionActionId: this.selectedActionId,
        dueBy: this.selectedDueBy,
        details: this.details,
        derivations: this.validDerivations,
        responsibleId: !this.past ? this.selectedResponsible.id : this.user.id,
        responsibleMessage: this.messageForResponsible
      }

      // Past attentions have some different values
      if (this.past) {
        return {
          ...baseInput,
          dueBy: this.selectedDueBy,
          performedAt: this.selectedDueBy,
          isDone: true
        }
      } else {
        return baseInput
      }
    },

    submit() {
      const input = this.getAttentionInput()
      // CREATE ATTENTION
      // Call the graphql mutation
      this.loading = true
      this.$apollo
        .mutate({
          // Query
          mutation: CREATE_ATTENTION,
          // Parameters
          variables: {
            input: input
          },
          refetchQueries: [
            { query: PROFILE_DETAIL, variables: { studentId: this.studentId } },
            { query: STUDENT_ATTENTIONS, variables: { studentId: this.studentId } }
          ]
        })
        .then(data => {
          // Result
          this.loading = false

          const {
            data: {
              createAttention: { id }
            }
          } = data

          if (this.past) {
            this.navigateTo({
              state: "app.profile.finish_attention",
              params: {
                attentionId: id
              }
            })
          } else {
            this.navigateTo({
              state: "app.profile.attention_created"
            })
          }
        })
        .catch(error => {
          this.loading = false
          console.error(error)
        })
    },
    cancel() {
      this.navigateTo({
        state: "app.profile.attentions"
      })
    }
  },
  components: {
    Block,
    AttentionTree,
    DerivationList,
    Multiselect
  }
}
</script>

<style scoped>
h4 {
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
}

.alert-derivation {
  margin-bottom: 35px;
}

.control-group {
  margin: 20px 0;
}

.control {
  margin: 10px 0;
}

select {
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  height: 35px;
  width: 300px;
  background-color: #f2f2f2;
}

textarea {
  box-sizing: border-box;
  resize: vertical !important;
  display: block;
  width: 100%;
  min-height: 66px;
  background-color: #f2f2f2;
  border-color: #e0e0e0;
  border-radius: 5px;
  padding: 10px 7px;
}

.attention-type,
.attention-details,
.responsible,
.attention-derivation {
  margin-bottom: 35px;
}

.responsible-message {
  display: block;
  box-sizing: border-box;
  width: 100%;
  background-color: #f2f2f2;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
  padding-left: 10px;
  height: 35px;
}

.attention-date {
  height: 35px;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
  background-color: #f2f2f2;
}

.derivation {
  margin: 10px 0;
}

.derivation .button {
  height: 35px;
  width: 37px;
}

.derivation textarea {
  margin-top: 10px;
}

.add-derivation {
  margin-top: 10px;
  border-width: 2px;
}

.actions .add {
  padding: 0 35px;
}
.actions .cancel {
  padding: 0 15px;
}

.multiselect-container {
  max-width: 500px;
}
</style>
